// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArticlesTagsSearch-module__container--K1EGE{display:flex;align-items:center;margin-top:8px;padding:9px 14px}.ArticlesTagsSearch-module__searchIcon--ZRRIp{width:13px;height:13px;fill:#d4d6d7}.ArticlesTagsSearch-module__searchInput--Epqpv{margin-left:8px;font-size:13px;font-weight:400}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ArticlesTagsSearch-module__container--K1EGE`,
	"searchIcon": `ArticlesTagsSearch-module__searchIcon--ZRRIp`,
	"searchInput": `ArticlesTagsSearch-module__searchInput--Epqpv`
};
export default ___CSS_LOADER_EXPORT___;
